// Adds the default "In stock" filter to collection links right before they are followed, so
// default-instock-filter.js doesn't have to redirect (which loads the collection page twice).
// Links to the current collection are left alone so shoppers can still clear the filter.
(function () {
  var COLLECTION_PATH = /\/collections\/[^\/]+\/?$/;

  function addFilter(event) {
    var link = event.target.closest && event.target.closest('a[href]');
    if (!link) return;
    try {
      var url = new URL(link.href, window.location.href);
      if (url.origin !== window.location.origin || !COLLECTION_PATH.test(url.pathname)) return;
      if (url.pathname === window.location.pathname) return;
      var hasFilter = Array.from(url.searchParams.keys()).some(function (k) { return k.indexOf('filter.') === 0; });
      if (hasFilter) return;
      url.searchParams.set('filter.v.availability', '1');
      link.href = url.toString();
    } catch (e) {}
  }

  document.addEventListener('click', addFilter, true);
  document.addEventListener('auxclick', addFilter, true);
})();
